import {
  ref,
  onValue,
  onDisconnect,
  Database,
  DatabaseReference,
} from 'firebase/database';
import { database as realtimeDb } from '../../config/firebase-client/database';

const RTDB_CONNECTION_PATH = '.info/connected';

export class ConnectionSentinel {
  private connectedRef: DatabaseReference;
  constructor(
    private realtimeRef: DatabaseReference,
    private onInit: () => Promise<void>,
    private onGracefulDisconnect: () => Promise<void>,
    /**
     * @remarks An update object that will be sent to the realtimeRef
     * when the connection is NOT closed gracefully, e.g., internet drops
     */
    private onConnectionDropped: () => Promise<Record<string, unknown>>,
    private onConnect: () => Promise<void>,
    private rtDb: Database = realtimeDb,
  ) {
    this.connectedRef = ref(this.rtDb, RTDB_CONNECTION_PATH);
  }

  public connect() {
    onValue(this.connectedRef, async (snapshot) => {
      if (!snapshot.val()) {
        await this.onInit();
      }
      onDisconnect(this.realtimeRef)
        .update(await this.onConnectionDropped())
        .then(this.onConnect);
    });
  }

  public disconnect() {
    this.onGracefulDisconnect();
  }
}
